<template>
  <div class="ui-radio-container" :class="{'disabled':disabled && greyoutDisabled}" v-on:click="clicked()">
    <div class="radio">
      <div class="unlit off" :class="{ 'lit': on}"></div>
    </div>

    <div class="label"><slot></slot></div>
   
  </div>
</template>

<script>
/* ! USAGE:
<ui-radio-group setting-name="group_name_for_local_saving" v-on:selected="method_to_invoke">
  <ui-radio  val="value_for_this_option" selected="true"/>
  <ui-radio  val="value_for_this_option"/>
</ui-radio-group>
*/

export default {
  name: 'ui-radio',
  props:{
    val:{default:"undefined"},
    selected:{default:false},
    disabled:{default:false},
    greyoutDisabled:{default:true}
  },
  data:function(){
    return {
      on:false,
    }
  },
  methods:{
    switchOn(){
      if(this.disabled){ return; }
      this.on=true;
    },
    clicked(){
      if(this.disabled){ return; }
      let vm=this.$parent;
      // emit to all parent who want to hear..
      while(vm){
        vm.$emit('clicked-ui-radio',this.val)
        vm=vm.$parent;
      }
     
      this.$root.$emit("all-group-off");
      this.on=true;
    },
    switch_off(){
      if(this.disabled){ return; }
      this.on=false;
    },
    registerToGroup(){
      let vm=this.$parent;
      while(vm){
        vm.$emit('register-ui-radio',this)
        vm=vm.$parent;
      }
    }
  },
 
  mounted(){
    this.on=this.selected
    this.registerToGroup();
    
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ui-radio-container{
  display:inline-flex;
  align-items: center;

  cursor:pointer;
}
.radio{
  position:relative;
  display:inline-block;
  border-radius:9999px;
  width:20px;
  height:20px;
  border:1px solid #CCCCCC;
  margin-right:5px;
  
}
.unlit{
  background-color:#FFFFFF;
  transition: background-color .25s ease-in-out;
}

.disabled{
  filter: grayscale(100%);
  opacity: .65;
  cursor:default!important;
}

.lit{
  background-color: #8cc63e;
  position:absolute;
  width:100%;
  height:100%;
  border-radius:9999px;
  border:1px solid white;
}
.label{
  /*flex:1;*/
}

</style>
